import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CaffeinateCampaignSchema = withDefaults({
  type: 'caffeinate-campaign',
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'slug',
    },
    {
      kind: 'attribute',
      name: 'active',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'subscriptionsCount',
    },
    {
      kind: 'attribute',
      name: 'activeSubscriptionsCount',
    },
    {
      kind: 'attribute',
      name: 'mailingsCount',
    },
    {
      kind: 'attribute',
      name: 'sentMailingsCount',
    },
    {
      kind: 'attribute',
      name: 'pendingMailingsCount',
    },
    {
      kind: 'attribute',
      name: 'skippedMailingsCount',
    },
    {
      kind: 'hasMany',
      name: 'caffeinateCampaignSubscriptions',
      type: 'caffeinate-campaign-subscription',
      options: {
        async: false,
        inverse: 'caffeinateCampaign',
      },
    },
  ],
});

export default CaffeinateCampaignSchema;
